import React from 'react';
import { FileText } from 'lucide-react';
import { Badge } from '../components/Badge';
export function Terms() {
  const sections = [{
    title: '1. Acceptance of Terms',
    body: 'By accessing or using Akios BOS, you agree to be bound by these Terms of Service. If you do not agree, you may not use our services.'
  }, {
    title: '2. Description of Service',
    body: 'Akios BOS is a cloud-based business operating system that provides inventory, CRM, finance, sales, project management, and analytics capabilities. We may modify or discontinue features at our discretion, with reasonable notice.'
  }, {
    title: '3. Accounts & Eligibility',
    body: 'You must be at least 18 years old and capable of forming a binding contract to use Akios BOS. You are responsible for safeguarding your account credentials and for all activity under your account.'
  }, {
    title: '4. Subscriptions & Billing',
    body: 'Paid plans are billed in advance on a monthly or annual basis. Fees are non-refundable except as required by law. We may change pricing with 30 days notice. You may cancel at any time; your subscription will continue until the end of your billing period.'
  }, {
    title: '5. Acceptable Use',
    body: 'You agree not to misuse Akios BOS, including but not limited to: reverse engineering, scraping, transmitting malware, or using the service for unlawful purposes. We may suspend or terminate accounts that violate these rules.'
  }, {
    title: '6. Customer Data',
    body: 'You retain ownership of all data you upload to Akios BOS. You grant us a limited license to host, process, and display your data solely as needed to provide the service. We will not access your data except as needed to provide support or as required by law.'
  }, {
    title: '7. Intellectual Property',
    body: 'Akios BOS, including its software, design, and content, is owned by Akios Edge Pvt. Ltd. and protected by applicable IP laws. We grant you a non-exclusive, non-transferable license to use Akios BOS in accordance with these Terms.'
  }, {
    title: '8. Disclaimer of Warranties',
    body: 'Akios BOS is provided "as is" without warranties of any kind, whether express or implied. We do not warrant that the service will be uninterrupted, error-free, or completely secure.'
  }, {
    title: '9. Limitation of Liability',
    body: 'To the maximum extent permitted by law, Akios Edge Pvt. Ltd. will not be liable for any indirect, incidental, special, or consequential damages. Our total liability is limited to the fees paid by you in the 12 months preceding the claim.'
  }, {
    title: '10. Governing Law',
    body: 'These Terms are governed by the laws of India. Any disputes will be resolved in the courts of Chennai, Tamil Nadu.'
  }, {
    title: '11. Changes to Terms',
    body: 'We may update these Terms from time to time. Continued use of Akios BOS after changes constitutes acceptance of the updated Terms.'
  }, {
    title: '12. Contact',
    body: 'Questions about these Terms? Reach us at akiosventure@gmail.com.'
  }];
  return <div className="w-full" data-id="element-558">
      <section className="pt-20 pb-12 bg-gradient-to-b from-white via-slate-50 to-indigo-50/40" data-id="element-559">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-560">
          <Badge icon={<FileText className="w-3.5 h-3.5" data-id="element-562" />} text="TERMS OF SERVICE" data-id="element-561" />
          <h1 className="text-4xl md:text-5xl font-black leading-tight tracking-tight mb-4 text-[#0B1020]" data-id="element-563">
            Terms of <span className="text-brand-blue" data-id="element-564">Service</span>
          </h1>
          <p className="text-slate-600" data-id="element-565">Last updated: May 1, 2026</p>
        </div>
      </section>

      <section className="py-16 bg-white" data-id="element-566">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-567">
          <p className="text-slate-600 leading-relaxed mb-10" data-id="element-568">
            These Terms of Service ("Terms") govern your access to and use of
            Akios BOS, operated by Akios Edge Pvt. Ltd. Please read them
            carefully.
          </p>
          <div className="space-y-8" data-id="element-569">
            {sections.map(s => <div key={s.title} data-id="element-570">
                <h2 className="text-xl font-bold text-slate-900 mb-3" data-id="element-571">
                  {s.title}
                </h2>
                <p className="text-slate-600 leading-relaxed" data-id="element-572">{s.body}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}